<template>
  <div>
    <!--投诉配置  -->
    <baseBreadcrumb :page="$t('message.complaintConfiguration')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <div class="search">
        <el-button type="success" class="fr" @click="add" v-if="isAuth(555)">{{ $t('message.add') }}</el-button>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- NO -->
          <el-table-column align="center" label="NO" type="index" width="100">
          </el-table-column>
          <!-- 更新时间 -->
          <el-table-column align="center" :label="$t('message.updateTime')" prop="created_at" width="150">
          </el-table-column>
          <!-- 投诉词汇 -->
          <el-table-column align="center" :label="$t('message.complaintVocabulary')" prop="keyword">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" width="150">
            <template slot-scope="scope">
              <i class="el-icon-edit-outline" @click="edit(scope.row)" v-if="isAuth(556)"></i>
              <i class="el-icon-delete-solid" @click="deleteChatKeywords(scope.row.id)" v-if="isAuth(557)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 添加修改 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible" width="580px" center>
      <div class="content">
        <!-- 投诉词汇 -->
        <div class="row">
          <div class="label">
            {{ $t("message.complaintVocabulary") }}
            ：
          </div>
          <div class="val">
            <el-input v-model="itemData.keyword" type="textarea"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
      $t("message.cancel")
    }}</el-button>
        <!-- 新增 -->
        <el-button type="primary" @click="addChatKeywords" v-if="isAdd">{{
      $t("message.ok")
    }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="updateChatKeywords" v-else>{{
      $t("message.ok")
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      itemData: {
        keyword: '',
      },
      title: '',
      isAdd: true,
      dialogVisible: false,
      tableData: []
    };
  },
  created() {
    this.getChatKeywords()
  },
  methods: {
    getChatKeywords() {
      this.$api.siteConfiguration.getChatKeywords(this.datas).then(res => {
        this.tableData = res.data
        this.total = res.data
      })
    },
    search() {
      this.datas.page = 1
      this.getChatKeywords()
    },
    // 新增
    add() {
      this.title = this.$t('message.add')
      this.itemData = {
        keyword: '',
      }
      this.isAdd = true
      this.dialogVisible = true
    },
    // 修改
    edit(item) {
      this.title = this.$t('message.edit')
      this.itemData = JSON.parse(JSON.stringify(item))
      this.isAdd = false
      this.dialogVisible = true
    },
    // 新增投诉词汇
    addChatKeywords() {
      let datas = {
        type: 1,
        keyword: this.itemData.keyword,
      }
      this.$api.siteConfiguration.addChatKeywords(datas).then(res => {
        this.$message.success(res.msg)
        this.getChatKeywords()
        this.dialogVisible = false
      })
    },
    // x修改投诉词汇
    updateChatKeywords() {

      this.$api.siteConfiguration.updateChatKeywords(this.itemData).then(res => {
        this.$message.success(res.msg)
        this.getChatKeywords()
        this.dialogVisible = false
      })
    },
    //删除投诉词汇
    deleteChatKeywords(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.siteConfiguration.deleteChatKeywords({ id }).then((res) => {
            this.$message.success(res.msg);
            this.getChatKeywords();
          });
        })
        .catch(() => { });

    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.getChatKeywords()
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.getChatKeywords()
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  height: 40px;
  margin-bottom: 24px;
}

i {
  font-size: 30px;
  margin-right: 20px;
  cursor: pointer;

  &:nth-last-child(1) {
    margin: 0;
  }

  &:hover {
    color: #b4272d
  }
}

.content {
  padding: 24px;

  .row {
    display: flex;

    .lable {
      width: 100px;
    }

    .val {
      flex: 1;
    }

  }
}
</style>